import { DateTime } from 'luxon';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  ⚠️ [D4.5 §3b, PROMOTED P6a] THE RANGE SURVIVES BACK-NAVIGATION, AND IT ALWAYS WAS IN
 *  THE URL.
 *
 *  Two pickers on the inbox had an `onChange` and no `value` — unlike the three filters
 *  beside them, which all read their state back. So the QUERY round-tripped through nuqs
 *  perfectly and the CONTROL did not: returning from a naming screen re-ran the right search
 *  and showed empty date boxes above it.
 *
 *  ⚠️ AN INVALID `DateTime` IS NOT `null`, AND rc-picker WILL RENDER IT. A hand-edited
 *  `?dateFrom=yesterday` must read as "no filter" rather than as a broken cell.
 *
 *  ⚠️ PARSED IN THE SYSTEM ZONE, NOT IST. rc-picker's luxon config builds a held value's visible
 *  month and its cells in that value's own zone, so a value in another zone selects the wrong cell
 *  at the day boundary. A date-only ISO string round-trips exactly through
 *  `DateTime.fromISO(s).toISODate()`, which is what every `onChange` writes — so the two
 *  halves are symmetric. [amended P7C.1 §5d] "Now" is no longer local: `DatePicker` answers
 *  `getNow` with `istNow()` ([P7C §6a]), so an EMPTY picker opens on the IST month and its Today
 *  is the IST day. Either way a cell's `toISODate()` is the day it shows — compare those strings,
 *  never instants.
 *
 *  ⚠️ PROMOTED OUT OF `pages/Inbox` BECAUSE THE DASHBOARD IS ITS SECOND CONSUMER. Two copies
 *  is how one screen ends up rejecting `?dateFrom=yesterday` while the other renders a broken
 *  cell — and the three traps above are precisely the kind that get copied without their
 *  reasons. `Attribute`'s promotion bar: the second consumer is when it moves.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const asPickerDate = (value: string | undefined | null): DateTime | null => {
  if (!value) return null;
  const parsed = DateTime.fromISO(value);
  return parsed.isValid ? parsed : null;
};

/** The other half of the round trip. `null` for a cleared picker, never `''`. */
export const fromPickerDate = (value: DateTime | null | undefined): string | null => value?.toISODate() ?? null;
